<template>
    <div>
      <v-dialog :class="themeClass" cen v-model="dialog" width="500" content-class="dialog-sobre">
  
        <v-card style="overflow-x: scroll;">

        <v-list-item>
        <v-list-item-content>
            <v-list-item-title style="font-size: 18px; font-weight: bold;">Usuário {{ this.user }}, você tem pendêntes:  </v-list-item-title>
        </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list>
            <v-list-item three-line class="card-item" v-for="(notification, index) in 
                notifications" :key="index">
                <v-list-item-content class="item-content">
                    <div @click="changeView(notification.id)">
                        <v-list-item-title style="margin-bottom: 4px;" @click="eventClick(notification.id, notification.link)">
                            <a :class="themeClass" >{{ notification.title || 'Notificação' }}</a>
                            <span style="margin: 5px;">{{ new Date(notification.createAt).toLocaleDateString() }}</span>
                        </v-list-item-title>
                        <div class="d-flex" >
                            <div class="row"  style="margin: -6px -3px" @click="eventClick(notification.id, notification.link)">
                                <div class="col-11 d-flex">
                                    <v-list-item-subtitle style="font-weight: bold;">{{ notification.description }}</v-list-item-subtitle>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </v-list-item-content>
            </v-list-item>


        </v-list>
        </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import packageConfig from "../../../package.json";
  import Vue from "vue";
  export default {
    data() {
      return {
        version: packageConfig.version,
        dialog: false,
        versionApi: "",
        user: "",
        notifications: []
      };
    },

    methods: {

        async eventClick(id, link) {
            // await this.viewNotification(id) // Caso você tenha essa lógica previamente

            if (link !== null) {
                if (link.startsWith("http://") || link.startsWith("https://")) {
                    // Abrir navegação externa em nova aba
                    window.open(link, "_blank");
                } else {
                    // Abrir navegação interna em nova aba
                    const fullUrl = this.$router.resolve(link).href; // Resolve a rota interna
                    window.open(fullUrl, "_blank");
                }

                this.menu = false;
            }
        },

        async changeView(id) {
            const notification = this.notifications.find(notification => notification.id === id)
            notification.view = "Sim";
            await Vue.prototype.$http.put(`/Entity/Alert`, notification)
            this.messages--
        },

        async getNotification(){
            const user = await this.$auth.getUserParams();
            // console.log(user);
            this.userId = user.userId;

            let req = await Vue.prototype.$http.get(`/Entity/Alert/search-fields`, { 
                params: { 
                    searchFields: "view,user", 
                    value: `Não,${this.userId}`, 
                    page: 1, 
                    limit: 10 
                }
            });

           

            this.notifications = [];

            if (req?.data?.data?.total > 0) {
                this.dialog = true;
                this.notifications = this.notifications.concat(req.data.data.data);

                this.messages = 0;

                this.notifications.forEach((resp) => {
                    console.log('resp >>>', resp);

                    if (resp?.userId === user.userId) {
                        if (resp?.view === "Não") {
                            this.messages++;
                        }
                    } else {
                        if (resp?.view === "Não") this.messages++;
                    }
                });
            }

            // console.log(this.notifications)


        },

        async startInterval() {
            // Executa a função a cada 2 minutos (120000 ms)
            this.intervalId = setInterval(async () => {
                await this.getNotification()
                 // Exemplo de execução
            }, 600000);
        },

        stopInterval() {
            // Para o intervalo
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
    },

    computed: {
        themeClass() {
        return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
        },
    },

    watch: {
        async page(){
            await this.getNotification()
        }
    },

    async created(){
        this.getNotification()
        this.user = (await this.$auth.getUserParams()).user
    },
  
    mounted() {
      this.startInterval();
    },

    beforeDestroy(){
        this.stopInterval();
    }
  };
  </script>
  
  <style scoped>
  .style-i {
    color: white;
    font-size: 22px;
}
/*
.style-i:hover {
    color: white;
}*/

.item-content {
    border-bottom: 1px solid rgba(172, 168, 168, 0.719);
}

a {
    color: black;
    margin-left: 5px;
    color: black;
}


span {
    float: right;
    font-size: 10px;
}
.card-item{
    position: relative;
}

.card-item:hover {
    cursor: pointer;
    background-color: whitesmoke;
}

.btn-aprovar, .btn-enviar-obs {
    background-color: green;
    border-radius: 15px;
    padding: 6px;
    color: white;
    font-size: 12px;
    margin: 0px 8px;
}

.btn-aprovar:hover, .btn-enviar-obs:hover {
    background-color: white;
    border: 1px solid green;
    color: green;
}

.btn-reprovar, .btn-cancelar-obs {
    background-color: red;
    border-radius: 15px;
    padding: 6px;
    color: white;
    font-size: 12px;
    margin: 0px 8px;
}

.btn-reprovar:hover, .btn-cancelar-obs:hover {
    background-color: white;
    border: 1px solid red;
    color: red;
}

.obs-container {
    margin-top: 3px;
    border: 1px solid #c5c0c0;
    padding: 5px;
}

.span-enviado {
    position: absolute;
    right: 15px;
    bottom: 2px;
}

.v-list-item__content{
    padding: 0px;
    max-height: 75px;
}

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .linkA{
    color: #000
  }

  .light-theme {
    color: #000;
  }

  .dark-theme {
    color: white !important;
  }

  </style>
  